<template>
  <div class="relative w-full overflow-hidden">
    
    <div 
      class="flex ease-in-out"
      :class="{'transition-transform duration-500': isTransitioning}"
      :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
    >
      <div 
        v-for="(image, index) in slides" 
        :key="index" 
        class="flex-shrink-0 w-full h-80 relative bg-gray-200"
      >
        <img :src="image.url" :alt="image.label" class="w-full h-full object-cover" />
        <div class="absolute bottom-0 left-0 right-0 h-10 bg-black/50 flex items-center justify-center">
          <span class="text-white text-sm">{{ image.label }}</span>
        </div>
      </div>
    </div>

    <button 
      @click.stop="prevSlide" 
      class="absolute top-1/2 left-4 -translate-y-1/2 bg-white w-8 h-8 flex items-center justify-center rounded-full text-black hover:bg-gray-200 transition-colors duration-200 z-10 shadow-lg"
      aria-label="Previous slide"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
      </svg>
    </button>
    
    <button 
      @click.stop="nextSlide" 
      class="absolute top-1/2 right-4 -translate-y-1/2 bg-white w-8 h-8 flex items-center justify-center rounded-full text-black hover:bg-gray-200 transition-colors duration-200 z-10 shadow-lg"
      aria-label="Next slide"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
      </svg>
    </button>
    
    <div class="absolute w-24 m-auto bottom-4 left-0 right-0 flex justify-center space-x-2 z-10">
      <div 
        v-for="(image, index) in images" 
        :key="index"
        class="w-2 h-2 rounded-full cursor-pointer transition-colors"
        :class="{'bg-white': index === realIndex, 'bg-white/50 hover:bg-white/80': index !== realIndex}"
        @click="goToSlide(index)"
      ></div>
    </div>
  </div>
</template>

<script>
// ... (Script 保持不变) ...
export default {
  props: ['images'],
  data() {
    return {
      currentIndex: 1, 
      intervalId: null,
      autoplayInterval: 4000,
      isTransitioning: true, 
    };
  },
  computed: {
    realImageCount() {
        return this.images.length;
    },
    slides() {
      if (this.images.length === 0) return [];
      if (this.images.length === 1) return this.images; 
      
      const first = this.images[0];
      const last = this.images[this.images.length - 1];
      
      return [last, ...this.images, first];
    },
    realIndex() {
        if (this.currentIndex === this.slides.length - 1) {
            return 0;
        }
        if (this.currentIndex === 0) { 
            return this.realImageCount - 1;
        }
        return this.currentIndex - 1; 
    }
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    startAutoPlay() {
      if (this.realImageCount > 1) {
        this.stopAutoPlay(); 
        this.intervalId = setInterval(this.nextSlide, this.autoplayInterval);
      }
    },
    stopAutoPlay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    
    nextSlide() {
      this.stopAutoPlay();
      this.isTransitioning = true;
      this.currentIndex++;
      
      if (this.currentIndex === this.slides.length - 1) {
        setTimeout(() => {
          this.isTransitioning = false;
          this.currentIndex = 1;
        }, 500); 
      }
      
      this.startAutoPlay();
    },
    
    prevSlide() {
      this.stopAutoPlay();
      this.isTransitioning = true;
      this.currentIndex--;
      
      if (this.currentIndex === 0) {
        setTimeout(() => {
          this.isTransitioning = false;
          this.currentIndex = this.slides.length - 2;
        }, 500);
      }
      
      this.startAutoPlay();
    },
    
    goToSlide(realIndex) {
      this.isTransitioning = true; 
      this.currentIndex = realIndex + 1;
      this.stopAutoPlay();
      this.startAutoPlay(); 
    },
  }
};
</script>

<style scoped>
/* 确保轮播图容器的宽度是其内部元素的 N 倍 */
.flex > div {
  width: 100%;
}
</style>